var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94269 4.99999L9.47136 8.52866C9.73202 8.78932 9.73202 9.21133 9.47136 9.47133C9.21069 9.73133 8.78869 9.73199 8.52869 9.47133L5.00002 5.94266L1.47136 9.47133C1.21069 9.73199 0.788691 9.73199 0.528691 9.47133C0.268691 9.21066 0.268024 8.78866 0.528691 8.52866L4.05736 4.99999L0.528691 1.47133C0.268024 1.21066 0.268024 0.78866 0.528691 0.52866C0.789358 0.26866 1.21136 0.267994 1.47136 0.52866L5.00002 4.05733L8.52869 0.52866C8.78936 0.267994 9.21136 0.267994 9.47136 0.52866C9.73136 0.789327 9.73202 1.21133 9.47136 1.47133L5.94269 4.99999Z",
    fill: "#969A9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXSmall);
export default __webpack_public_path__ + "static/media/icon-x-small.b44c5f7f.svg";
export { ForwardRef as ReactComponent };